import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const Button = styled(BaseButton)(() => ({
  maxWidth: '230px',
  width: '150px'
}));

export const FooterActions = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: theme.spacing(-1),
  padding: `${theme.spacing(4)} 0`,
  [`& ${Button}`]: {
    margin: theme.spacing(1),
    '@media (max-width: 400px)': {
      flexGrow: 1
    }
  }
}));
